import ApprovalPage from "../../components/approvalPage/approvalPage";
import { PLATFORM_ROLES, User } from "../models/abacConfig";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import TuneIcon from "@mui/icons-material/Tune";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SendIcon from "@mui/icons-material/Send";
import SettingsIcon from "@mui/icons-material/Settings";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";

export const INFINITE = Number.MAX_SAFE_INTEGER;
export const ALLOWED_DELIVERY_PARTY =
  process.env.REACT_APP_ALLOWED_DELIVERY_PARTY || "[]";
export const ALLOWED_SHOPIFY_PARTY =
  process.env.REACT_APP_ALLOWED_SHOPIFY_PARTY || "[]";

export const PRISM_API_BASE_URL =
  process.env.REACT_APP_PRISM_API_BASE_URL ||
  "https://api.prismprocure.ai/prism-api/v1";
export const PRISM_PUBLIC_URL =
  process.env.REACT_APP_PRISM_PUBLIC_URL || "https://dev.prismprocure.ai";
export const PRISM_WHATSAPP_NUMBER =
  process.env.REACT_APP_PRISM_WHATSAPP_NUMBER || "919318395277";
export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirectPath";
export const TEMP_PRISM_API_BASE_URL =
  process.env.REACT_APP_PRISM_PAYMENT_API_BASE_URL ||
  "https://a4bgo47pqe.execute-api.ap-south-1.amazonaws.com/dev/prism-api/v1";

// OAuth Configuration
export const OAUTH_CONFIG = {
  COGNITO_DOMAIN:
    process.env.REACT_APP_COGNITO_DOMAIN ||
    "dev-prism-auth.auth.ap-south-1.amazoncognito.com",
  CLIENT_ID:
    process.env.REACT_APP_COGNITO_CLIENT_ID || "2nuhm5sil21tla66rlr4t67c00",
  REGION: process.env.REACT_APP_COGNITO_REGION || "ap-south-1",
  REDIRECT_URI:
    process.env.REACT_APP_OAUTH_REDIRECT_URI ||
    "https://dev.prismprocure.ai/auth/callback",
  SCOPES: "email openid profile",
  RESPONSE_TYPE: "CODE",
};

const PRISM_FILE_UPLOAD_BASE_URL =
  process.env.REACT_APP_PRISM_FILE_UPLOAD_BASE_URL;
const PRISM_INVOICE_FILE_UPLOAD_BASE_URL =
  process.env.REACT_APP_PRISM_INVOICE_FILE_UPLOAD_BASE_URL ||
  "https://h5vm3zrxrzaz2m4hopho36yvhy0ganef.lambda-url.ap-south-1.on.aws";
const ACCOUNTING_LEDGER_PROCESSOR_BASE_URL =
  process.env.REACT_APP_ACCOUNTING_LEDGER_PROCESSOR_BASE_URL ||
  "https://h5vm3zrxrzaz2m4hopho36yvhy0ganef.lambda-url.ap-south-1.on.aws";

// API Endpoints
// Discovery Agent Configuration
export const DISCOVERY_AGENT_API_BASE_URL =
  process.env.REACT_APP_DISCOVERY_AGENT_API_BASE_URL ||
  "https://y2g3rvptnrduampwpcwk5j7wpi0zdhcb.lambda-url.ap-south-1.on.aws/prism-api/v1";
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyDy4C1WeXsQjjxto7ogDPh3lb3dbZCDDMg";

export const API_ENDPOINTS = {
  getRFQ: `${PRISM_API_BASE_URL}/order/request`,
  getRFQStatus: `${PRISM_API_BASE_URL}/order/request`,
  uploadRFQContents: `${PRISM_FILE_UPLOAD_BASE_URL}/order/request/uploadContent`,
  deleteContent: `${PRISM_API_BASE_URL}/order/request/deleteContent`,
  createRFQ: `${PRISM_API_BASE_URL}/order/request/create`,
  fetchRequestItemContent: `${PRISM_API_BASE_URL}/content/request/fetchRequestContentByContentIds`,
  updateRFQ: `${PRISM_API_BASE_URL}/order/request/update`,
  getRFQList: `${PRISM_API_BASE_URL}/order/request/getAll`,
  getRequestProformaList: `${PRISM_API_BASE_URL}/order/getRequestProformaList`,
  getDashboardData: `${PRISM_API_BASE_URL}/order/dashboard/stats`,
  downloadRFQ: `${PRISM_API_BASE_URL}/order/request/:rfqId/downloadRequestPdf`,
  downloadRFQExcel: `${PRISM_API_BASE_URL}/order/request/downloadRequestSheet`,
  downloadComparisonMatrix: `${PRISM_API_BASE_URL}/order/request/downloadComparisonMatrixPdf`,

  getQuote: `${PRISM_API_BASE_URL}/quote`,
  getQuoteStatus: `${PRISM_API_BASE_URL}/quote`,
  createQuote: `${PRISM_API_BASE_URL}/quote/create`,
  updateQuote: `${PRISM_API_BASE_URL}/quote/update`,
  getQuoteList: `${PRISM_API_BASE_URL}/quote/getAll`,
  getQuotesByRequestId: `${PRISM_API_BASE_URL}/quote/all/request`,
  downloadQuotePdf: `${PRISM_API_BASE_URL}/quote/generateQuotePdf`,
  downloadQUoteItemsExcel: `${PRISM_API_BASE_URL}/order/request/:requestId/downloadRequestSheet`,
  uploadQuoteContents: `${PRISM_API_BASE_URL}/quote/uploadContent`,
  getQuoteContent: `${PRISM_API_BASE_URL}/quote/getContent`,

  getOrder: `${PRISM_API_BASE_URL}/order`,
  createOrder: `${PRISM_API_BASE_URL}/order/create`,
  createOrderStandalone: `${PRISM_API_BASE_URL}/order/createOrderStandalone`,
  getOrderList: `${PRISM_API_BASE_URL}/order/getAll`,
  getOrderStatusHistory: `${PRISM_API_BASE_URL}/order/ORDER_ID/statuses`,
  updateOrderContactMech: `${PRISM_API_BASE_URL}/order/ORDER_ID/updateOrderContactMech`,
  generateThreeWayComparison: `${PRISM_API_BASE_URL}/order/threeway/generate`,
  generateInvoiceFromAccounts: `${PRISM_API_BASE_URL}/order/invoice/acc`,
  getRemainingOrderItems: `${PRISM_API_BASE_URL}/order/generatePDF/remainingItems/:orderId`,
  getOrderStatusDashboard: `${PRISM_API_BASE_URL}/order/dashboard/status`,

  // fileUpload: `http://localhost:8000/prism-api/v1/order/upload-document`,
  //fileUpload: `${PRISM_API_BASE_URL}/order/upload-document`,

  fileUpload: `${PRISM_FILE_UPLOAD_BASE_URL}/order/upload-document`,
  fileUploadPresignedUrl: `${PRISM_FILE_UPLOAD_BASE_URL}/fileprocessor/getUploadUrl`,

  fileUploadOrderInvoice: `${PRISM_API_BASE_URL}/order/upload-document-with-parsing`,

  invoiceFileUpload: `${PRISM_INVOICE_FILE_UPLOAD_BASE_URL}/process-invoice`,
  updateOrderStatus: `${PRISM_API_BASE_URL}/order/:orderId/status-update`,
  updateOrderItem: `${PRISM_API_BASE_URL}/order/item/update`,
  deliverOrderApi: `${PRISM_API_BASE_URL}/order/deliver`,

  createRepeatOrder: `${PRISM_API_BASE_URL}/order/repeat-order`,
  updateRepeatOrder: `${PRISM_API_BASE_URL}/order/repeat-order/:roId`,
  getRepeatOrder: `${PRISM_API_BASE_URL}/order/repeat-order/getAll`,
  getRepeatOrderById: `${PRISM_API_BASE_URL}/order/repeat-order/:roId`,
  acceptRepeatOrder: `${PRISM_API_BASE_URL}/order/repeat-order/:roId/accept`,

  getPartyById: `${PRISM_API_BASE_URL}/party/:partyid`,
  updateParty: `${PRISM_API_BASE_URL}/party/update`,
  deleteParty: `${PRISM_API_BASE_URL}/party/delete`,
  getPartiesProductType: `${PRISM_API_BASE_URL}/party/productType/partiesProductType`,
  createPartyProductType: `${PRISM_API_BASE_URL}/party/productType/create`,
  updatePartyProductType: `${PRISM_API_BASE_URL}/party/productType/update`,
  createPartyPref: `${PRISM_API_BASE_URL}/party/partyPreference/create`,
  updatePartyPref: `${PRISM_API_BASE_URL}/party/partyPreference/update`,
  getPartyPref: `${PRISM_API_BASE_URL}/party/:partyid/getPartyPreferences`,
  createBankDetails: `${PRISM_API_BASE_URL}/party/updateBankAccount`,
  updateBankDetails: `${PRISM_API_BASE_URL}/party/updateBankDetails`,
  getBankDetails: `${PRISM_API_BASE_URL}/party/bankDetails`,
  uploadFileParty: `${PRISM_API_BASE_URL}/party/upload-document`,
  getPartyToken: `${PRISM_API_BASE_URL}/party/:partyId/getPartyToken`,
  createPartyToken: `${PRISM_API_BASE_URL}/party/createPartyToken`,
  searchParties: `${PRISM_API_BASE_URL}/party/fetchParties`,
  verifySellerDetails: `${PRISM_API_BASE_URL}/party/verifySellerDetails`,

  downloadOrderPdf: `${PRISM_API_BASE_URL}/order/generateOrderPdf`,
  // use Party not User
  addParty: `${PRISM_API_BASE_URL}/party/create`,
  createMember: `${PRISM_API_BASE_URL}/party/create-member`,
  fetchPermissions: `${PRISM_API_BASE_URL}/common/permission/permissions`,
  fetchAllSecurityGroups: `${PRISM_API_BASE_URL}/common/securitygroup/securityGroups`,
  // fetchOrgPartyDetails: `${PRISM_API_BASE_URL}/party/getOrgParties`,
  createCustomSecurityGroup: `${PRISM_API_BASE_URL}/common/securitygroup/create`,
  // for local testing use the local endpoints
  // createCustomSecurityGroup: `http://localhost:3001/prism-api/v1/common/securitygroup/create`,
  updateCustomSecurityGroup: `${PRISM_API_BASE_URL}/common/securitygroup/update`,
  // updateCustomSecurityGroup: `http://localhost:3001/prism-api/v1/common/securitygroup/update`,
  getSecurityGroup: `${PRISM_API_BASE_URL}/common/securitygroup/securityGroups`,
  // createPartyPreference: `${PRISM_API_BASE_URL}/party/partyPreference/create`,
  createPartyRelationships: `${PRISM_API_BASE_URL}/party/linkparties`,
  getAllRelationshipTypes: `${PRISM_API_BASE_URL}/common/relationshipType/all`,
  removeRelationshipTypes: `${PRISM_API_BASE_URL}/party/relationships/remove`,

  updatePartyContactMech: `${PRISM_API_BASE_URL}/party/contactmech/update`,
  createPartyContactMech: `${PRISM_API_BASE_URL}/party/contactmech/create`,

  createOrderGRN: `${PRISM_API_BASE_URL}/order/grn`,
  editOrderGRN: `${PRISM_API_BASE_URL}/order/grn`,
  getGRNList: `${PRISM_API_BASE_URL}/order/grn/getAll`,
  ackGRN: `${PRISM_API_BASE_URL}/order/grn/acknowledge`,
  getGRNById: `${PRISM_API_BASE_URL}/order/grn/:grnId`,
  getGRNByOrderId: `${PRISM_API_BASE_URL}/order/:orderId/grn`,
  getGRNPDF: `${PRISM_API_BASE_URL}/order/grn/generateGrnPdf`,
  invoiceAfterGRN: `${PRISM_API_BASE_URL}/order/grn/invoice`,

  createPartyContent: `${PRISM_API_BASE_URL}/content/party/create`,
  getPartyContent: `${PRISM_API_BASE_URL}/content/party/:partyId/content`,
  createOrderContent: `${PRISM_API_BASE_URL}/content/order/create`,
  updateOrderContent: `${PRISM_API_BASE_URL}/content/order/update`,
  fetchOrderContent: `${PRISM_API_BASE_URL}/content/order/:orderId/content`,
  createGRNContent: `${PRISM_API_BASE_URL}/content/grn/create`,
  fetchGRNContent: `${PRISM_API_BASE_URL}/content/grn/:goodsReqChallanId`,

  createInvoiceContent: `${PRISM_API_BASE_URL}/content/invoice/create`,
  updateInvoiceContent: `${PRISM_API_BASE_URL}/content/invoice/update`,
  fetchInvoiceContent: `${PRISM_API_BASE_URL}/content/invoice/:invoiceId/content`,

  getAllGeoLocations: `${PRISM_API_BASE_URL}/common/getAllGeoLocations`,
  createCommunication: `${PRISM_API_BASE_URL}/notification/communication`,

  getUOMByType: `${PRISM_API_BASE_URL}/common/uom/getAll?typeId=`,

  getNotificationLogs: `${PRISM_API_BASE_URL}/notification/getNotificationLogsByPartyId/:partyId`,
  updateNotificationLogsStatus: `${PRISM_API_BASE_URL}/notification/updateNotificationLogsStatus`,

  //URLS To be changed once included under domain
  downloadRequestReportExcel: `${PRISM_API_BASE_URL}/report/downloadRequestReportExcel`,
  downloadOrderReportExcel: `${PRISM_API_BASE_URL}/report/downloadOrderReportExcel`,
  downloadAccountStatementExcel: `${PRISM_API_BASE_URL}/report/downloadAccountStatementExcel`,
  downloadPaymentDetailsExcel: `${PRISM_API_BASE_URL}/report/downloadPaymentDetailsExcel`,
  getReport: `${PRISM_API_BASE_URL}/report/getReport`,
  categoryWiseRequestItemsReport: `${PRISM_API_BASE_URL}/order/reports/categoryWiseRequestItemsReport`,
  getclientWiseMonthlyOrderReport: `${PRISM_API_BASE_URL}/order/reports/clientWiseMonthlyPurchaseReport`,
  getclientWiseMonthlyInvoiceReport: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/generate/clientMonthly/report`,
  getInventoryReport: `${PRISM_API_BASE_URL}/order/reports/monthlyItemInventoryReport`,

  fetchAllProductTypes: `${PRISM_API_BASE_URL}/order/productTypes/getAll`,
  sendOtp: `${PRISM_API_BASE_URL}/common/send-otp`,
  verifyOtp: `${PRISM_API_BASE_URL}/common/verify-otp`,

  forgotPasswordSendOtp: `${PRISM_API_BASE_URL}/party/forgotPassword/sendOtp`,
  forgotPasswordVerifyOtp: `${PRISM_API_BASE_URL}/party/forgotPassword/verifyOtp`,
  partyResetAccountPassword: `${PRISM_API_BASE_URL}/party/resetAccountPassword`,

  createCommEvent: `${PRISM_API_BASE_URL}/communication/communication/create`,
  getCommEventById: `${PRISM_API_BASE_URL}/communication/communication/get`,
  getCommThread: `${PRISM_API_BASE_URL}/communication/communication/get/thread/:referenceId/:commEventType`,

  getReturnReasons: `${PRISM_API_BASE_URL}/order/return/reasons`,

  createFacility: `${PRISM_API_BASE_URL}/facility/create`,
  updateFacility: `${PRISM_API_BASE_URL}/facility/update`,
  searchFacilities: `${PRISM_API_BASE_URL}/facility/getFacilities`,
  getFacilityById: `${PRISM_API_BASE_URL}/facility/:facilityId`,
  createPartyTags: `${PRISM_API_BASE_URL}/party/tags`,
  getPartyTags: `${PRISM_API_BASE_URL}/party/tags/getAll`,
  deactivateTag: `${PRISM_API_BASE_URL}/party/tags/:tagId/deactivate`,

  getInventoryItems: `${PRISM_API_BASE_URL}/facility/inventory/getInventoryItems`,
  getInventoryItemById: `${PRISM_API_BASE_URL}/facility/inventory/:inventoryItemId`,
  updateInventoryItem: `${PRISM_API_BASE_URL}/facility/inventory/update`,
  inventoryBulkUpload: `${PRISM_API_BASE_URL}/facility/inventory/bulkUpload`,
  inventorySearchItemIssuance: `${PRISM_API_BASE_URL}/facility/inventory/issuance/search`,
  inventoryCreateItemIssuance: `${PRISM_API_BASE_URL}/facility/inventory/issuance/create`,
  inventoryUpdateItemIssuance: `${PRISM_API_BASE_URL}/facility/inventory/issuance/update`,
  inventoryUpdateItemIssuanceStatus: `${PRISM_API_BASE_URL}/facility/inventory/issuance/updateStatus`,
  inventoryGetItemIssuanceById: `${PRISM_API_BASE_URL}/facility/inventory/issuance/:inventoryItemId`,
  inventoryGetItemActivityDetails: `${PRISM_API_BASE_URL}/facility/inventory/activity/details`,
  inventoryUpdateItemActivity: `${PRISM_API_BASE_URL}/facility/inventory/activity/update`,
  inventoryGetItemIssuanceRequestById: `${PRISM_API_BASE_URL}/facility/inventory/issuanceRequest/:itemIssuanceRequestId`,
  inventorySearchItemIssuanceRequest: `${PRISM_API_BASE_URL}/facility/inventory/issuanceRequest/search`,
  inventoryUpdateItemIssuanceRequest: `${PRISM_API_BASE_URL}/facility/inventory/issuanceRequest/update`,
  inventoryUpdateItemIssuanceRequestApproval: `${PRISM_API_BASE_URL}/facility/inventory/issuanceRequest/updatedApprovalStatus`,
  inventoryFetchRejectedItemsExcel: `${PRISM_API_BASE_URL}/facility/inventory/getRejectedItemsExcel`,

  searchProducts: `${PRISM_API_BASE_URL}/product/getProducts`,
  getProductById: `${PRISM_API_BASE_URL}/product/:productId`,
  mergeProducts: `${PRISM_API_BASE_URL}/product/merge`,
  createProduct: `${PRISM_API_BASE_URL}/product/create`,
  getCatalogueStatus: `${PRISM_API_BASE_URL}/product/catalogue-status`,
  updateProduct: `${PRISM_API_BASE_URL}/product/update`,

  createPayment: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/payment/create`,
  updatePaymentStatus: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/payment/updatePaymentStatus`,
  getPaymentTypes: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/payment/getPaymentTypes`,
  getPaymentMethodTypes: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/payment/getPaymentMethodTypes`,

  registerUsingOTP: `${PRISM_API_BASE_URL}/party/registerUsingOTP`,
  registerVerifyGST: `${PRISM_API_BASE_URL}/party/registerVerifyGST`,
  updatePartyVendor: `${PRISM_API_BASE_URL}/party/update`,

  downloadInvoicePdf: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/invoice/downloadPdf`,
  getBuyerInvoiceStats: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/invoice/stats`,
  updatePaymentInvoice: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/invoice/update`,
  updatePaymentInvoiceStatus: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/invoice/updateInvoiceStatus`,
  searchPaymentInvoice: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/invoice/searchInvoice`,
  getPaymentInvoiceById: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/invoice/:invoiceId`,
  createExternalInvoice: `${TEMP_PRISM_API_BASE_URL}/paymentInvoice/invoice/createExternalInvoice`,
  ingestInvoiceToTally: `${ACCOUNTING_LEDGER_PROCESSOR_BASE_URL}/ingest-tally`,

  createContract: `${PRISM_API_BASE_URL}/order/rateContract`,
  getAllContract: `${PRISM_API_BASE_URL}/order/rateContract`,
  getContractPagination: `${PRISM_API_BASE_URL}/order/rateContract/paginated/list`,
  getContractById: `${PRISM_API_BASE_URL}/order/rateContract/:contractId`,
  createOrderFromRateContract: `${PRISM_API_BASE_URL}/order/create/rateContract`,

  // Discovery Agent endpoints
  discoveryAgentChat: `${DISCOVERY_AGENT_API_BASE_URL}/prismcopilot/agents/product-assistant/`,
  googleMapsGeocode: `https://maps.googleapis.com/maps/api/geocode/json`,
  // OAuth Endpoints
  getGoogleOAuthUrl: `${PRISM_API_BASE_URL}/auth/google/url`,
  oauthCallback: `${PRISM_API_BASE_URL}/auth/google/callback`,

  getShopifyList: `${PRISM_API_BASE_URL}/product/getProducts`,
  getShopifyProductByProductId: `${PRISM_API_BASE_URL}/product/shopify/:shopifyProductId`,
  postShopifyProduct: `${PRISM_API_BASE_URL}/product/shopify/product/set`,
  putShopifyProduct: `${PRISM_API_BASE_URL}/product/shopify/product/set`,
  postTransferPrismOrderToShopify: `${PRISM_API_BASE_URL}/product/shopify/product/transfer/order`,

  getAllProformaInvoice: `${PRISM_API_BASE_URL}/proformaInvoice/getAll`,
  getProformaInvoiceById: `${PRISM_API_BASE_URL}/proformaInvoice/:proformaInvoiceId`,
  downloadProformaInvoicePdf: `${PRISM_API_BASE_URL}/proformaInvoice/downloadPdf`,
};

export const PAGES_URL = {
  DASHBOARD: "/dashboard",
  ORDERMGR: "/ordermgr",
  VIEW_RFQ: "control/ViewRequest",
  CREATE_RFQ: "control/CreateRequest",
  UPDATE_RFQ: "control/UpdateRequest",
  RFQ_LIST: "control/rfqList",
  CREATE_COMPARISON_MATRIX: "control/generate-comparison-matrix",
  APPROVAL_OVERVIEW: "control/approvalOverview",
  CREATE_PO_MATRIX: "control/order/create-matrix",
  QUOTEMGR: "/quotemgr",
  CREATE_QUOTE: "control/CreateQuote",
  UPDATE_QUOTE: "control/UpdateQuote",
  VIEW_QUOTE: "control/ViewQuote",
  VIEW_ORDER: "control/ViewOrder",
  ORDER_LIST: "control/OrderList",
  GENERATE_ORDER_PDF: "control/GeneratePDF",
  QUOTES_LIST: "control/quotesList",
  SEND_OTP: "/sendOtp",
  VERIFY_OTP: "/verifyOtp",
  GST_DETAILS: "/gstDetails",
  ORDER_DETAILS: "control/orderDetails",
  RFQ_HISTORY: "control/rfqHistory",
  ORDER_HISTORY: "control/orderHistory",
  APPROVAL_PAGE: "components/approvalPage/approvalPage",
  SETTINGS: "settings",
  PROFILE: "profile",
  TRACKING: "tracking",
  VIEW_ALL_ORDER_GRN: "control/allGrn",
  VIEW_GRN: "control/grn",
  HELP: "help",
  CLONE_RFQ: "clone",
  GRN_LIST: "control/grnList",
  GRN_VIEW: "control/grn/:orderId/:grnId",
  REPORTING: "reporting",
  CHOOSE_RO: "repeat/order/select",
  CREATE_RO: "repeat/order/create",
  VIEW_RO: "repeat/order/view",
  INVENTORY: "inventory",
  INVENTORY_ITEM_DETAILS: "inventory/itemDetails",
  INVENTORY_ISSUANCE_REQUEST_LIST: "inventory/issuanceRequestList",
  INVENTORY_ISSUANCE_REQUEST_CREATE: "inventory/createIssueRequest",
  INVENTORY_ISSUANCE_REQUEST_VIEW: "inventory/issueRequest",
  INVENTORY_MERGE: "inventory/merge",
  SELLER_ONBOARDING: "seller/onboarding",
  UPCOMING: "upcoming",
  RO_LIST: "roList",
  BIDS: "bids",
  ORDERS: "orders",
  ACCOUNT_MGR: "accmgr",
  PAYMENT_INVOICE: "paymentInvoice",
  PROFORMA_INVOICE: "proformaInvoice",
  PROFORMA_INVOICE_CREATE: "proformaInvoice/create",
  PROFORMA_INVOICE_UPDATE: "proformaInvoice/update",
  INVOICE: "invoice",
  INVOICE_CREATE: "invoice/create",
  INVOICE_UPDATE: "invoice/update",
  INVOICE_PUSH_ERP: "invoice/push-erp",
  CREATE_GRN: "control/createGrn",
  EDIT_GRN: "control/edit/grn",
  CREATE_ORDER: "control/CreateOrder",
  DISCOVERY_AGENT: "discovery-agent",
  THREE_WAY_MATCH: "control/threewaymatch",
  RATE_CONTRACT_CREATE: "control/contract/create",
  RATE_CONTRACT_LIST: "control/contract/list",
  RATE_CONTRACT_VIEW: "control/contract/view",
  SUBSCRIPTION: "subscription",
};

export const REGEX = {
  inputStringGeneralCharacters: /^[a-zA-Z0-9.,_\-\s/\\:]+$/,
  decimalValue: /^-?\d+(\.\d+)?$/,
  noSpecialCharactersInput: /^[a-zA-Z0-9 ]*$/, // Regular expression to match alphanumeric characters and whitespace
};

export const loggedInUser: User = {};
export const UserAuthorizationRules: any = {};
export const UserRole: any = {};
export const UserPermissions: any = {};
export const PARTY_ACTIVE_STATUS = "PARTY_ACTIVE";
export const PARTY_INACTIVE_STATUS = "PARTY_IN_ACTIVE";

export const SIDEBAR_ID = {
  DASHBOARD: "Dashboard",
  CREATE_RFQ: "CreateRFQ",
  RFQ_LIST: "ListRFQ",
  ORDER_LIST: "ListOrder",
  GRN_LIST: "ListGRN",
  SETTINGS: "SettingPage",
  HELP: "HelpPage",
  REPORTING: "Reporting",
  HOME: "Home",
  DISCOVERY_AGENT: "Discovery Agent",
  BIDS: "Bids",
  REPEAT_ORDER: "Repeat Order",
  ORDERS: "Orders",
  PROFILE: "Profile",
  LOGOUT: "Logout",
  INVENTORY: "Inventory",
  SELLERS: "Sellers",
  CONTRACTS: "Contracts",
  MARKET: "Marketplace",
  INVOICE: "Invoicing",
  COMPLIANCE: "Compliance",
  WORK_ORDER: "Work Order",
  BILL: "Bill of Quantities",
  CONTRACT: "Contract",
  RATE_CONTRACT: "Rate Contract",
  PROFORMA_INVOICE: "Proforma Invoice",
};

export const Request_Statuses = {
  REQUEST_DRAFT: "REQUEST_DRAFT",
  REQUEST_CREATED: "REQUEST_CREATED",
  REQUEST_UPDATED: "REQUEST_UPDATED",
  REQUEST_REJECTED: "REQUEST_REJECTED",
  REQUEST_COMPLETED: "REQUEST_COMPLETED",
  REQUEST_APPROVED: "REQUEST_APPROVED", // Added since it was missing from API,
  REQUEST_CLOSED: "REQUEST_CLOSED",
};

export const RequestStatusDisplayNames = {
  REQUEST_DRAFT: "Draft",
  REQUEST_CREATED: "Created",
  REQUEST_REJECTED: "Rejected",
  REQUEST_COMPLETED: "Completed",
};

export const pageAccessByRoles: any = {
  [PLATFORM_ROLES.SUPER_ADMIN]: [
    "ApprovalPage",
    "BusinessDetails",
    "SocietyDetails",
    "BankDetails",
    "Users",
  ],
  [PLATFORM_ROLES.SOCIETY_MEMBER]: [
    "Users",
    "Roles and Permissions",
    "Address",
    // "Preferred Vendors",
    "Configuration",
  ],
  // [PLATFORM_ROLES.SOCIETY_ADMIN]: ["SocietyDetails", "AddUsers"],
  [PLATFORM_ROLES.SOCIETY_ADMIN]: [
    "Users",
    "Roles and Permissions",
    "Address",
    // "Preferred Vendors",
    "Configuration",
    "Store",
  ],
  [PLATFORM_ROLES.VENDOR_ADMIN]: ["BusinessDetails", "BankDetails"],
};
export const PAGE_BASED_SETTINGS_ICONS = {
  Users: PeopleOutlineIcon,
  "Roles and Permissions": TuneIcon,
  Address: LocalShippingIcon,
  "Preferred Vendors": SendIcon,
  Configuration: SettingsIcon,
  Store: StoreMallDirectoryIcon,
};
export const cookieNames = {
  jwtToken: "jwtTokenBuyer",
  tokenExpiryTime: "tokenExpiryTimeBuyer",
  orgPartyName: "orgPartyNameBuyer",
  prismUser: "prismUserBuyer",
  subscription: "subscriptionBuyer",
};

export const DATE_FORMAT = {
  ISO_FORMAT: "DD-MM-YYYY",
  DB_FORMAT: "",
  TIME_FORMAT: "HH:mm",
};

export const ITEM_STATUS = {
  DRAFT: "ITEM_DRAFT",
  CREATED: "ITEM_CREATED",
  APPROVED: "ITEM_APPROVED",
  REJECTED: "ITEM_REJECTED",
  COMPLETED: "ITEM_COMPLETED",
  DELIVERED: "ITEM_DELIVERED",
  RETURNED: "ITEM_RETURNED",
  PARTIALLY_ACCEPTED: "ITEM_PARTIALLY_ACCEPTED",
  PARTIALLY_RETURNED: "ITEM_PARTIALLY_RETURNED",
  CANCELLED: "ITEM_CANCELLED",
};

export const ITEM_STATUS_LABEL: any = {
  ITEM_DRAFT: "Draft",
  ITEM_CREATED: "Created",
  ITEM_APPROVED: "Approved",
  ITEM_REJECTED: "Rejected",
  ITEM_COMPLETED: "Completed",
  ITEM_DELIVERED: "Delivered",
  ITEM_RETURNED: "Returned",
  ITEM_PARTIALLY_ACCEPTED: "Partially Accepted",
  ITEM_PARTIALLY_RETURNED: "Partially Returned",
  ITEM_CANCELLED: "Cancelled",
};

export const RFQ_STATUS: any = {
  REQUEST_APPROVED: "Bidding Open",
  APPROVED: "Approved",
  REQUEST_DRAFT: "Draft",
  REQUEST_CREATED: "Created",
  REQUEST_COMPLETED: "Completed",
  REQUEST_REJECTED: "Rejected",
  REQUEST_UPDATE: "Draft",
  REQUEST_CLOSED: "Closed for Bidding",
  REQUEST_UPDATED: "Updated",
};

export const QUOTE_STATUS: any = {
  QUOTE_APPROVED: "Approved",
  QUOTE_DRAFT: "Draft",
  QUOTE_CREATED: "Created",
  QUOTE_UPDATE: "Updated",
  QUOTE_CLOSED: "Closed",
  QUOTE_REJECTED: "Rejected",
  QUOTE_SUBMITTED: "Submitted",
};

export const PO_STATUS: any = {
  ORDER_APPROVED: "Approved",
  ORDER_DRAFT: "Draft",
  ORDER_CREATED: "Created",
  ORDER_CLOSED: "Closed",
  ORDER_REJECTED: "Rejected",
  ORDER_CANCELLED: "Cancelled",
  ORDER_PROCESSING: "Processing",
  ORDER_DELIVERED: "Delivered",
  INVOICE_CREATED: "Invoice created",
  "3_WAY_MATCH_APPROVED": "Invoice Accepted",
  "3_WAY_MATCH_REJECTED": "3 way match rejected",
  PAYMENT_APPROVED: "Payment approved",
  ORDER_SUBMITTED: "Submitted",
  ORDER_INTRANSIT: "Intransit",
  ORDER_DELAYED: "Delayed",
  ORDER_ACCEPTED: "Invoice Accepted",
  ORDER_COMPLETED: "Completed",
  PAYMENT_REJECTED: "Payment rejected",
  ORDER_UPDATED: "Updated",
};

export const RO_STATUS: any = {
  REPEAT_ORDER_DRAFT: "Draft",
  REPEAT_ORDER_CREATED: "Created",
  REPEAT_ORDER_NEGOTIATION: "Negotiation",
  REPEAT_ORDER_COMPLETED: "Completed",
  REPEAT_ORDER_CANCELLED: "Cancelled",
};

export const RFQ_ITEMS: any = [
  "Furniture",
  "Civil",
  "Electronics",
  "Electrical",
  "Fire",
  "Horticulture",
  "Housekeeping",
  "Plumbing",
  "Polymers",
  "Hardware",
  "Sanitary",
  "Tools",
];
// export const RFQ_ITEMS_MAPPING:any = {
//   "Furniture":"FURNITURE",
//   "Civil":"CIVIL",
//   "Electronics":"ELECTRONICS",
//   "Electrical":"ELECTRICAL",
//   "Fire":"FIRE",
//   "Horticulture":"HORTICULTURE",
//   "Housekeeping":"HOUSEKEEPING",
//   "Plumbing":"PLUMBING",
//   "Polymers":"POLYMERS",
//   "Hardware":"HARDWARE",
//   "Sanitary":"SANITARY",
//   "Tools":"TOOLS"
// };
// export const RFQ_ITEMS_NAME_MAPPING:any = {
//   "FURNITURE":"Furniture",
//   "CIVIL":"Civil",
//   "ELECTRONICS":"Electronics",
//   "ELECTRICAL":"Electrical",
//   "FIRE":"Fire",
//   "HORTICULTURE":"Horticulture",
//   "HOUSEKEEPING":"Housekeeping",
//   "PLUMBING":"Plumbing",
//   "POLYMERS":"Polymers",
//   "HARDWARE":"Hardware",
//   "SANITARY":"Sanitary",
//   "TOOLS":"Tools"
// };

export const RFQ_UOM: any = [
  { name: "Not Applicable", label: "Not Applicable" },
  { name: "Bags", label: "Bags" },
  { name: "Box", label: "Box" },
  { name: "Bundle", label: "Bundle" },
  { name: "Days", label: "Days" },
  { name: "Dozen", label: "Dozen" },
  { name: "Feet", label: "Feet" },
  { name: "Gm", label: "Gm" },
  { name: "KG", label: "KG" },
  { name: "Length", label: "Length" },
  { name: "LTR", label: "LTR" },
  { name: "NOS", label: "NOS" },
  { name: "Pair", label: "Pair" },
  { name: "PCS", label: "PCS" },
  { name: "Pkt", label: "Pkt" },
  { name: "Qty", label: "Qty" },
  { name: "Rim", label: "Rim" },
  { name: "Roll", label: "Roll" },
  { name: "Set", label: "Set" },
  { name: "SQF", label: "SQF" },
  { name: "Ton", label: "Ton (Tonnes)" },
  { name: "MTR", label: "MTR" },
  { name: "SQM", label: "SQM" },
];

// Added to make constant for rfq details
export const RFQItems_Column = [
  { id: "item", label: "Name", colSpan: "42%" },
  // { id: "hsnCode", label: "HSN/SAC", colSpan: "12%" },
  { id: "brandName", label: "Brand", colSpan: "10%" },
  { id: "size", label: "Specification", colSpan: "14%" },
  { id: "quantityUOM", label: "UOM", colSpan: "10%" },
  { id: "quantity", label: "Quantity", colSpan: "14%" },
  { id: "actions", label: "Actions", colSpan: "10%" },
  // { id: "itemTypeId", label: "Category", colSpan: "12%" },
];

export const RFQItemsView_Column = [
  { id: "item", label: "Name", colSpan: "42%" },
  // { id: "hsnCode", label: "HSN/SAC", colSpan: "12%" },
  { id: "brandName", label: "Brand", colSpan: "15%" },
  { id: "size", label: "Specification", colSpan: "19%" },
  { id: "quantityUOM", label: "UOM", colSpan: "10%" },
  { id: "quantity", label: "Quantity", colSpan: "14%" },
  // { id: "actions", label: "Actions", colSpan: "10%" },
  // { id: "itemTypeId", label: "Category", colSpan: "12%" },
];

// Added to make constant for quote from buyer details
export const RFQ_QUOTES = [
  { id: "quote", label: "Quote ID", length: 20 },
  { id: "sname", label: "Seller Name", length: 20 },
  { id: "itemSize", label: "Number of Items", length: 14 },
  { id: "amount", label: "Total Amount ( excl. GST )", length: 18 },
  { id: "status", label: "Status", length: 18 },
];

// Added to render data accordingly
export const RFQDetail_Column_TYPES = {
  CONSTANT: "constant",
  LENGTH: "length",
  DATE: "date",
  NUMBER: "number",
  STRING: "string",
};

// Added to make constant for view rfq table
export const RFQDetail_Column = [
  {
    label: "Status",
    id: "statusId",
    type: RFQDetail_Column_TYPES.CONSTANT,
    constant: RFQ_STATUS,
  },
  {
    label: "Number of Bids",
    id: "submittedQuotesCount",
    type: RFQDetail_Column_TYPES.NUMBER,
  },
  {
    label: "Number of Orders",
    id: "orders",
    type: RFQDetail_Column_TYPES.LENGTH,
  },
  {
    label: "Bid Date",
    id: "expectedQuoteDate",
    type: RFQDetail_Column_TYPES.DATE,
  },
  {
    label: "Delivery Date",
    id: "expectedDeliveryDate",
    type: RFQDetail_Column_TYPES.DATE,
  },
  {
    label: "Payment Terms",
    id: "paymentTerms",
    type: RFQDetail_Column_TYPES.NUMBER,
  },
  {
    label: "Total Items",
    id: "itemsCount",
    type: RFQDetail_Column_TYPES.NUMBER,
  },
];

//head columns for create and edit RFQ using wizard
export const RFQ_WIZARD_HEAD_ITEMS: any = {
  rfqName: {
    label: "Request Name",
    placeholder: "Enter Request Name",
  },
  expectedQuoteDate: {
    label: "Bid End Date",
    placeholder: "End Date",
    tooltipTitle:
      "Sellers will not be able to submit quotes after this date.\n This should be atleast 2 days later than the request creation date.",
  },
  expectedDeliveryDate: {
    label: "Expected Delivery Date",
    placeholder: "End Date",
    tooltipTitle:
      "Date by when you are expecting delivery of goods.\n This should be atleast 1 day later than the bid end date",
  },
  paymentTerms: {
    label: "Payment Terms",
    placeholder: "Payment terms",
  },
  category: {
    label: "Select Category Name",
    placeholder: "Search Category Here",
  },
  seller: {
    label: "Select preferred sellers for notification of this Request",
    placeholder: "Search Seller",
  },
  commPrism: {
    label: "Send notification of this Request to all Prism sellers.",
  },
};

export const RFQ_INPUT_TABLE_ROW: any = {
  itemName: {
    placeholder: "Item Name",
  },
  itemType: {
    placeholder: "Category",
  },
  brandName: {
    placeholder: "Brand",
  },
  itemSize: {
    placeholder: "Specification",
  },
  quantityUOM: {
    placeholder: "UOM",
  },
  quantity: {
    placeholder: "Quantity",
  },
};

export const ORDER_INPUT_TABLE_ROW: any = {
  item: {
    placeholder: "Item Name",
  },
  itemTypeId: {
    placeholder: "Category",
  },
  brandName: {
    placeholder: "Brand",
  },
  itemSize: {
    placeholder: "Specification",
  },
  quantityUOM: {
    placeholder: "UOM",
  },
  quantity: {
    placeholder: "Quantity",
  },
  unitPrice: {
    placeholder: "Unit Price",
  },
  gst: {
    placeholder: "GST %",
  },
  amount: {
    placeholder: "Amount",
  },
  hsn: {
    placeholder: "HSN",
  },
};

export const dashboardRfqStatuses: any = {
  Default: "",
  All: "REQUEST_ALL",
  Draft: "REQUEST_DRAFT",
  "Bidding Open": "REQUEST_APPROVED_OPEN",
  Completed: "REQUEST_COMPLETED",
  Approved: "REQUEST_APPROVED",
};

export const dashboardOrderStatuses: any = {
  Default: "",
  All: "ORDERS_ALL",
  Created: "ORDER_CREATED",
  Draft: "ORDER_DRAFT",
  Processing: "ORDER_PROCESSING",
  Delivered: "ORDER_DELIVERED",
  "Invoice created": "INVOICE_CREATED",
  "Invoice Accepted": "ORDER_ACCEPTED",
  Rejected: "ORDER_REJECTED",
  Cancelled: "ORDER_CANCELLED",
  Closed: "ORDER_CLOSED",
  Completed: "ORDER_COMPLETED",
  Updated: "ORDER_UPDATED",
};

export const dashboardROStatuses: any = {
  Default: "",
  All: "RO_ALL",
  Draft: "REPEAT_ORDER_DRAFT",
  Created: "REPEAT_ORDER_CREATED",
  Negotiation: "REPEAT_ORDER_NEGOTIATION",
  Completed: "REPEAT_ORDER_COMPLETED",
  Cancelled: "REPEAT_ORDER_CANCELLED",
};

export const OrderDetail_Column = {
  RFQ_ID: "Request ID",
  QUOTE_ID: "Quote ID",
  REF_PO_NUM: "Reference PO Number",
  ORDER_STATUS: "Order status",
  FULFILLED_BY: "Fulfilled by",
  DELIVERY_DATE: "Delivery date",
  CREATION_DATE: "Creation date",
};

export const RepeatOrderDetail_Column = {
  RO_ID: "Repeat Order ID",
  ORDER_STATUS: "Order status",
  FULFILLED_BY: "Fulfilled by",
  DELIVERY_DATE: "Delivery date",
  CREATION_DATE: "Creation date",
};

export const RateContractOrderDetail_Column = {
  RC_ID: "Rate Contract ID",
  ORDER_STATUS: "Order status",
  FULFILLED_BY: "Fulfilled by",
  DELIVERY_DATE: "Delivery date",
  CREATION_DATE: "Creation date",
};

export const ProformaInvoiceOrderDetail_Column = {
  PROFORMA_ID: "Proforma Invoice ID",
  REF_PO_NUM: "Reference PO Number",
  ORDER_STATUS: "Order status",
  FULFILLED_BY: "Fulfilled by",
  DELIVERY_DATE: "Delivery date",
  CREATION_DATE: "Creation date",
};

export const OrderDetail_Contact_Column = {
  NAME: "Name",
  EMAIL: "Email Address",
  CONTACT_NO: "Contact number",
};
export const OrderDetail_Billing_Column = {
  BILLING_ADDRESS: "Billing Address",
  SHIPPING_ADDRESS: "Shipping Address",
};
export const Order_Contact_Purpose_Type = {
  SHIPPING_LOCATION: "SHIPPING_ADDRESS",
  BILLING_LOCATION: "BILLING_ADDRESS",
  PRIMARY_EMAIL: "EMAIL",
  PRIMARY_PHONE: "PRIMARY_PHONE",
};

export const Order_Total_Amount = {
  totalAmount: "Subtotal",
  totalTaxAmount: "Tax",
  grandTotal: "Total Amount",
};
export const POItems_Column = [
  {
    id: "item",
    label: "Name/Brand",
    colSpan: 2,
    subName: "HSN Code",
    subId: "hsnCode",
  },
  {
    id: "quantity",
    label: "Quantity UOM",
    colSpan: 2,
    subName: "Specification",
    subId: "size",
  },
  {
    id: "deliveredQuantity",
    label: "Delivered Quantity",
    colSpan: 2,
  },
  {
    id: "itemTypeId",
    label: "Category",
    colSpan: 2,
  },
  // {
  //   id: "returnReasonId",
  //   label: "Reason Code",
  //   colSpan: 2,
  // },
  {
    id: "deliveryStatus",
    label: "Delivery Status",
    colSpan: 2,
  },
  {
    id: "finalUnitPrice",
    label: "Unit Price (₹)",
    colSpan: 2,
    subName: "GST(%)",
    subId: "gst",
  },
  {
    id: "amount",
    label: "Amount (₹)",
    colSpan: 2,
    subName: "Tax Amount (₹)",
    subId: "taxAmount",
    align: "right",
  },
];

export const CONFIGURATION_CONSTANTS = {
  PAYMENT_TERM: "Payment Terms",
  TnC: "PO Terms and Conditions",
  SEND_RFQ: "Send Request",
  SIGNATURE: "Signature",
  GST_NUMBER: "GST number",
  ACCOUNT_HOLDER: "Account holder",
  BANK_NAME: "Bank name",
  IFSC_CODE: "IFSC Code",
  ACCOUNT_NUMBER: "Account number",
  TIN_NUMBER: "TIN number",
  PAN_NUMBER: "PAN number",
  COMMUNICATION: "Mode of communication",
  STAMP: "Organisation Stamp",
  ORGLOGO: "Organisation Logo",
  REPEAT_ORDER: "Repeat Order Limit",
  TAGS: "Define Tags",
  DEFAULT_BID_DATE: "Default Bid Duration (Days)",
  PREFERENCE_MODES: {
    PREF_VENDORS: "ONLY_PREF_VENDORS",
    COMMUNICATION_MODE: "COMMUNICATION_MODE",
    PAYMENT_TERMS: "DEFAULT_PAYMENT_TERMS",
    REPEAT_ORDER_LIMIT: "REPEAT_ORDER_LIMIT",
    PO_SEQUENCE: "PO_SEQUENCE",
    DEFAULT_TNC: "DEFAULT_TNC",
    DEFAULT_BID_DATE: "DEFAULT_BID_DATE",
  },
  SEND_RFQ_VALUES: {
    ALL_VENDORS: "allVendors",
    PREFERRED_VENDORS: "preferredVendors",
  },
  PAYMENT_TERMS_VALUES: {
    DAYS30: "30 DAYS",
    DAYS60: "60 DAYS",
    DAYS90: "90 DAYS",
    OTHER: "OTHER",
  },
  COMMUNICATION_MODE_VALUES: {
    SMS: "SMS",
    WHATSAPP: "WHATSAPP",
    EMAIL: "EMAIL",
  },
  INPUT_ID: {
    PAYMENT_TERM: "paymentTerm",
    O_PAYMENT_TERM: "otherPaymentTerm",
    SEND_RFQ: "sendRFQChoice",
    SIGNATURE: "Signature",
    GST_NUMBER: "gstNumber",
    ACCOUNT_HOLDER: "accountHolder",
    BANK_NAME: "bank",
    IFSC_CODE: "ifscNumber",
    ACCOUNT_NUMBER: "accountNo",
    C_ACCOUNT_NUMBER: "CaccountNo",
    TIN_NUMBER: "tinNumber",
    PAN_NUMBER: "panNumber",
    COMMUNICATION: "comm",
    REPEAT_ORDER: "repeatValue",
    TAGS: "tags",
    PO_PREFIX: "poPrefix",
    PO_START: "poStart",
    PO_CURRENT: "poCurrent",
    TnC: "tnc",
    DEFAULT_BID_DATE: "defaultBidDate",
  },
  PO_SEQUENCE: {
    PREFIX: "PREFIX",
    START: "START",
    CURRENT: "CURRENT",
    SEQUENCE: "Purchase Order Sequence",
  },
};
export const RFQ_PERMISSION_MAP = {
  R: ["REQUEST_VIEW"],
  W: ["REQUEST_VIEW", "REQUEST_CREATE", "REQUEST_UPDATE", "REQUEST_DELETE"],
  NA: [],
};
export const ORDER_PERMISSION_MAP = {
  R: ["ORDER_VIEW"],
  W: ["ORDER_VIEW", "ORDER_CREATE", "ORDER_UPDATE", "ORDER_DELETE"],
  NA: [],
};
export const APPROVAL_PERMISSION_MAP = {
  R: ["RFQ_APPROVAL"],
  W: ["RFQ_APPROVAL", "QUOTE_APPROVAL"],
  NA: [],
};
export const COMPARISION_MATRIX_PERMISSION_MAP = {
  R: ["QUOTES_COMPARE_VIEW"],
  W: ["QUOTE_APPROVAL", "QUOTES_COMPARE_VIEW"],
  NA: [],
};

export const REPEAT_ORDER_PERMISSION_MAP = {
  R: ["REPEAT_ORDER_VIEW"],
  W: ["REPEAT_ORDER_CREATE", "REPEAT_ORDER_UPDATE", "REPEAT_ORDER_VIEW"],
  NA: [],
};

export const ROLE_MAPPING = {
  ADMIN: "Admin",
  SUPER_ADMIN: "Super Admin",
  // VENDOR_ADMIN: "Vendor Admin", Not applicable for buyer side
  SOCIETY_ADMIN: "Organization Admin",
  SOCIETY_MEMBER: "Organization Member",
  L1_APPROVER: "L1",
  L2_APPROVER: "L2",
  L3_APPROVER: "L3",
  L4_APPROVER: "L4",
  L5_APPROVER: "L5",
};
export const PERMISSION_MAPPING = {
  PARTYMGR_VIEW: "User View",
  PARTYMGR_CREATE: "User Create",
  PARTYMGR_UPDATE: "User Update",
  PARTYMGR_DELETE: "User Delete",
  PARTYMGR_ADMIN: "User Admin",
  REQUEST_VIEW: "View Request",
  REQUEST_CREATE: "Create Request",
  REQUEST_UPDATE: "Update Request",
  REQUEST_DELETE: "Delete Request",
  ORDER_VIEW: "View Order",
  ORDER_CREATE: "Create Order",
  ORDER_UPDATE: "Update Order",
  ORDER_DELETE: "Delete Order",
  ORDER_ADMIN: "Order Admin",
  QUOTE_VIEW: "View Quote",
  QUOTE_CREATE: "Create Quote",
  QUOTE_UPDATE: "Update Quote",
  QUOTE_DELETE: "Delete Quote",
  QUOTES_COMPARE_VIEW: "View Comparision Matrix",
  RFQ_APPROVAL: "Approve Request",
  QUOTE_APPROVAL: "Approve Quote",
  SECURITYGROUP_CREATE: "Create Security Group",
  SECURITYGROUP_UPDATE: "Update Security Group",
  GRN_CREATE: "Create GRN",
  CONTENT_CREATE: "Create Content",
  CONTENT_UPDATE: "Update Content",
  CONTENT_DELETE: "Delete Content",
  ACCOUNTS_PAYABLE_ADMIN: "Accounts Payable Admin",
  ACCOUNTS_PAYABLE_CREATE: "Create Accounts Payable",
  ACCOUNTS_PAYABLE_UPDATE: "Update Accounts Payable",
  ACCOUNTS_PAYABLE_VIEW: "View Accounts Payable",
  ACCOUNTS_PAYABLE_DELETE: "Delete Accounts Payable",
  ORDER_THREE_WAY_MATCH_VIEW: "Order 3 Way Match View",
  ORDER_THREE_WAY_MATCH_UPDATE: "Order 3 Way Match Update",
  ORDER_PAYMENT_VIEW: "Order Payment View",
  ORDER_PAYMENT_UPDATE: "Order Payment Update",
  ORDER_INVOICE_VIEW: "Order Invoice View",
  ORDER_INVOICE_UPDATE: "Order Invoice Update",
  REPEAT_ORDER_VIEW: "Repeat Order View",
  REPEAT_ORDER_CREATE: "Repeat Order Create",
  REPEAT_ORDER_UPDATE: "Repeat Order Update",
  REPEAT_ORDER_ACCEPT: "Repeat Order Accept",
  FACILITY_VIEW: "Facility View",
  FACILITY_CREATE: "Facility Create",
  FACILITY_UPDATE: "Facility Update",
  FACILITY_DELETE: "Facility Delete",
  FACILITY_ADMIN: "Facility Admin",
  PRODUCTMGR_UPDATE: "Product Update",
  PRODUCTMGR_CREATE: "Product Create",
  PRODUCTMGR_VIEW: "Product View",
  PRODUCTMGR_DELETE: "Product Delete",
  PRODUCTMGR_ADMIN: "Product Admin",
  ITEM_ISSUANCE_APPROVER: "Item Approve",
};
// export const GENERATE_GROUP_ID = (groupName:string)=> {
//   return groupName.replace(/ /g, '_').toLocaleUpperCase();

// }
export const RELATIONSHIP_TYPE = {
  MEMBER: "MEMBER",
  PREFERRED_VENDOR: "PREFERRED_VENDOR",
  SOCIETY_MEMBER: "SOCIETY_MEMBER",
};

export const APPROVAL_ITEM_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  REMAINING: "REMAINING",
  REJECTED_REMAINING: "REJECTED_REMAINING",
  CURRENT: "CURRENT",
};

export const BANK_STATUS = {
  ACTIVE: "BANK_ACCOUNT_ACTIVE",
  EXPIRED: "BANK_ACCOUNT_EXPIRED",
};

export const PARTY_TYPE = {
  GROUP: "PARTY_GROUP",
  PERSON: "PERSON",
};

export const APPROVAL_NAME_MAPPING = {
  L1_APPROVER: "L1_APPROVER",
  L2_APPROVER: "L2_APPROVER",
  L3_APPROVER: "L3_APPROVER",
  L4_APPROVER: "L4_APPROVER",
  L5_APPROVER: "L5_APPROVER",
};

export const UPLOAD_FILE_PURPOSE_TYPE = {
  RFQ_FILE: "RFQ_FILE",
  GENAI_QUOTE_FILE: "GENAI_QUOTE_FILE",
  PROFILE_PICTURE: "PROFILE_PICTURE",
  STAMP: "ORG_STAMP",
  ORG_LOGO: "ORG_LOGO",
  PAYMENT: "PAYMENT_CHEQUE",
  INVOICE_FILE: "INVOICE",
  SIGNATURE: "SIGNATURE",
  REQUEST_CONTENT: "REQUEST_ITEM_FILE",
  QUOTE_DOCS: "QUOTE_DOCS",
  INVENTORY_BULK_UPLOAD_FILE: "INVENTORY_BULK_UPLOAD_FILE",
  HELP_FILE: "HELP_FILE",
  GENAI_ORDER_FILE: "GENAI_ORDER_FILE",
  RATE_CONTRACT_FILE: "RATE_CONTRACT_FILE",
  ORDER_EXTERNAL_INVOICE: "ORDER_EXTERNAL_INVOICE",
  DIRECT_INVOICE: "DIRECT_INVOICE",
  SIGNED_DELIVERY_CHALLAN: "SIGNED_DELIVERY_CHALLAN",
  SIGNED_INVOICE: "SIGNED_INVOICE",
  SIGNED_PO: "SIGNED_PO",
};

export const UPLOAD_FILE_CONTENT_NAME = {
  PROFILE_PICTURE: "Profile Picture",
  STAMP: "Organisation Stamp",
  PAYMENT: "Payment Cheque",
  SIGNATURE: "Signature",
  ORG_LOGO: "Organisation Logo",
  HELP: "Help",
  INVOICE: "Invoice",
  SIGNED_DELIVERY_CHALLAN: "Signed Delivery Challan",
  SIGNED_INVOICE: "Signed Invoice",
  SIGNED_PO: "Signed Purchase Order",
};

export const UPLOAD_FILE_CONTENT_TYPE = {
  IMAGE: "IMAGE_OBJECT",
  INVOICE: "Invoice",
  DOCUMENT: "DOCUMENT",
};

export const getExtensionFromMimeType = (mimeType: string): string => {
  const mimeToExtensionMap: any = {
    "image/png": ".png",
    "image/jpeg": ".jpg",
    "image/jpg": ".jpg",
  };
  return mimeToExtensionMap[mimeType] || ""; // Return empty string if type is not mapped
};

export const THREE_WAY_MATCH_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  PROCESSED: "PROCESSED",
};

export const PAYMENT_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  UPLOADED: "UPLOADED",
};

export const ORDER_STATUS = {
  DRAFT: "ORDER_DRAFT",
  CREATED: "ORDER_CREATED",
  SUBMITTED: "ORDER_SUBMITTED",
  APPROVED: "ORDER_APPROVED",
  PROCESSING: "ORDER_PROCESSING",
  INTRANSIT: "ORDER_INTRANSIT",
  DELAYED: "ORDER_DELAYED",
  DELIVERED: "ORDER_DELIVERED",
  DELIVERY_ACCEPTED: "ORDER_ACCEPTED",
  REJECTED: "ORDER_REJECTED",
  CANCELLED: "ORDER_CANCELLED",
  COMPLETED: "ORDER_COMPLETED",
  THREE_WAY_MATCH_APPROVED: "3_WAY_MATCH_APPROVED",
  PAYMENT_APPROVED: "PAYMENT_APPROVED",
  INVOICE: "INVOICE_CREATED",
  UPDATED: "ORDER_UPDATED",
};

export const INVOICE_STATUS = {
  INVOICE_CANCELLED: "INVOICE_CANCELLED",
};

export const LOCATION = {
  PRIMARY: "PRIMARY_LOCATION",
  BILLING: "BILLING_LOCATION",
  SHIPPING: "SHIPPING_LOCATION",
};

export const GRN_ORDER_DETAIL_COLUMN = {
  ORDER_ID: "Order ID",
  ORDER_STATUS: "Order status",
};
export const VIEW_GRN_DETAIL_COLUMN = {
  ORDER_ID: "Order ID",
  ORDER_STATUS: "Order status",
  GRN_STATUS: "GRN status",
  CREATED_DATE: "Created date",
  DELIVERY_DATE: "Delivery date",
};
export const GRN_TABLE_HEADINGS = {
  PRODUCT_DETAILS: "Product details",
  HSN_CODE: "HSN Code",
  SPECIFICATION: "Specification",
  QUANTITY: "Quantity/UOM",
  REASON_CODE: "Reason Code",
  STATUS: "Status",
};
export const VIEW_ALL_GRN_HEADINGS = {
  GRN_DETAILS: "GRN ID",
  STATUS: "GRN Status",
  CREATED_DATE: "Created Date",
  DELIVERY_DATE: "Delivery Date",
  NO_OF_ITEMS: "Number of items",
  // NO_OF_ITEMS:"Total items",
  ACTIONS: "Actions",
};
export const GRN_STATUS: any = {
  GRN_DRAFT: "Draft",
  GRN_CREATED: "Created",
  GRN_DELIVERED: "Delivered",
  GRN_DISPATCHED: "Dispatched",
  GRN_REJECTED: "Rejected",
  GRN_PENDING_ACKNOWLEDGEMENT: "Pending Ack",
  API_DELIVERED: "GRN_DELIVERED",
  API_REJECTED: "GRN_REJECTED",
  API_CREATED: "GRN_CREATED",
  API_DRAFT: "GRN_DRAFT",
  API_PENDING_ACKNOWLEDGEMENT: "GRN_PENDING_ACKNOWLEDGEMENT",
};

export const QUOTE_DETAILS_COLUMN: any = {
  QUOTE_NAME: {
    label: "Quote name",
    id: "quoteName",
  },
  PAYMENT_TERMS: {
    label: "Terms & Conditions",
    id: "description",
  },
  TABLE_ITEMS: [
    {
      label: "Product details",
      id: "productDetails",
      colSpan: "35%",
    },
    {
      label: "Specification",
      id: "specification",
      colSpan: "15%",
    },
    {
      label: "Quantity/UOM",
      id: "quantityUOM",
      colSpan: "15%",
    },
    {
      label: "Unit Price",
      id: "pricePerUnit",
      colSpan: "15%",
    },
    {
      label: "GST %",
      id: "gst",
      colSpan: "10%",
    },
    {
      label: "Amount",
      id: "amount",
      colSpan: "20%",
    },
  ],
};
export const dashboardGrnStatuses: any = {
  Default: "",
  All: "GRN_ALL",
  Draft: "GRN_DRAFT",
  Created: "GRN_CREATED",
  Delivered: "GRN_DELIVERED",
  Dispatched: "GRN_DISPATCHED",
  "Pending Ack": "GRN_PENDING_ACKNOWLEDGEMENT",
};

export const NOTIFICATION_CHANNEL_TYPES = {
  EMAIL: "EMAIL",
  SMS: "SMS",
  WHATSAPP: "WHATSAPP",
  PUSH: "PUSH",
};

export const NOTIFICATION_STATUS = {
  SENT: "SENT",
  DELIVERED: "DELIVERED",
  FAILED: "FAILED",
  PENDING: "PENDING",
  SEEN: "SEEN",
  READ: "READ",
};

export const TOKEN_PURPOSE_TYPE = {
  FIREBASE_PUSH_NOTIFICATION: "FIREBASE_PUSH_NOTIFICATION",
};

export const FIREBASE_NOTFICATIONS_KEY = {
  FIREBASE_API_KEY: "AIzaSyBfz22qrXX5QEBjmlnYo6bqblDIw4cLSww",
  FIREBASE_AUTH_DOMAIN: "prism-notifications-prod.firebaseapp.com",
  FIREBASE_PROJECT_ID: "prism-notifications-prod",
  FIREBASE_STORAGE_BUCKET: "prism-notifications-prod.appspot.com",
  FIREBASE_MESSAGE_SENDER_ID: "667836587569",
  FIREBASE_APP_ID: "1:667836587569:web:a612ff1c3771e898d4ff10",
  FIREBASE_MEASUREMENT_ID: "G-LVENCH1ERY",
  FIREBASE_VAPID_KEY:
    "BHAW6Tr3DSFdcR1bfyxUJydda3pEinYgAQMtUpqokIbjUaDwtutfL1HNNtoOQqVZf27Z5QTJcW57speY-BkVoek",
};

export const REPORTING_TYPE = {
  REQUEST_SUMMARY: "REQUEST_SUMMARY",
  ORDER_SUMMARY: "ORDER_SUMMARY",
  CONSUMPTION_REPORT: "CONSUMPTION_REPORT",
  ACCOUNT_STATEMENT: "ACCOUNT_STATEMENT",
  PAYMENT_DETAILS: "PAYMENT_DETAILS",
  ORDER_REPORT: "ORDER_REPORT",
  MONTHLY_ACCOUNTING_REPORT: "MONTHLY_ACCOUNTING_REPORT",
  FACILITY_REPORT: "FACILITY_REPORT",
};

export const THREEE_WAY_MATCH_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
};
export const three_way_match_reject = "3_WAY_MATCH_REJECTED";
export const payment_status_reject = "PAYMENT_REJECTED";

export const FILE_SUFFIX = {
  SIGNATURE: "_SIGNATURE",
  STAMP: "_STAMP",
  PROFILE: "_PROFILE",
  REQUEST_CONTENT: "_REQUEST_CONTENT",
  ORG_LOGO: "_ORG_LOGO",
  QUOTE_DOCS: "QUOTE_DOCS",
};

export const UOM_TYPE = {
  QUANTITY_MEASURE: "QUANTITY_MEASURE",
};

export const ORDER_ITEMS_COL = [
  { id: "itemSeqId", label: "Item#" },
  { id: "item", label: "Item Name" },
  { id: "brandName", label: "Brand Name" },
  { id: "size", label: "Specification" },
  { id: "quantityUOM", label: "Quantity UOM" },
  { id: "quantity", label: "Quantity" },
  { id: "itemTypeId", label: "Item Category" },
  { id: "status", label: "Status" },
  { id: "finalUnitPrice", label: "Unit Price (₹)" },
  { id: "gst", label: "GST(%)" },
  { id: "taxAmount", label: "Tax Amount (₹)" },
  { id: "amount", label: "Amount (₹)" },
];

export const COMM_EVENT = {
  NEGOTIATION: "NEGOTIATION",
};

export const MESSAGE_TYPES = {
  ERROR: "ERROR",
  WARNING: "WARNING",
  SUCCESS: "SUCCESS",
  INFO: "INFO",
};

export const INVENTORY_LIST_COLUMNS = {
  ITEM_ID: {
    id: "itemId",
    label: "Item ID",
    enableSort: true,
  },
  ITEM_NAME: {
    id: "itemName",
    label: "Item Name",
    enableSort: true,
  },
  HSN_CODE: {
    id: "hsnCode",
    label: "HSN/SAC",
    enableSort: true,
  },
  AVAILABLE_STOCK: {
    id: "quantity",
    label: "Available Stock",
    enableSort: true,
  },
  STORE_NAME: {
    id: "storeName",
    label: "Store Name",
    enableSort: true,
  },
  LAST_MODIFIED_DATE: {
    id: "lastModifiedDate",
    label: "Last modified date",
    enableSort: true,
  },
  TAGS: {
    id: "tags",
    label: "Tags",
    enableSort: false,
  },
  ACTIONS: {
    id: "actions",
    label: "Actions",
    enableSort: false,
  },
};
export const INVENTORY_ITEM_DETAILS_COLUMNS = {
  ACTIVITY_NAME: {
    id: "activityName",
    label: "Activity Name",
    enableSort: false,
    width: "16%",
  },
  ACTIVITY_ID: {
    id: "activityId",
    label: "Activity ID",
    enableSort: false,
    width: "16%",
  },
  REASON: {
    id: "reason",
    label: "Reason",
    enableSort: false,
    width: "16%",
  },
  CREATED_DATE: {
    id: "createdDate",
    label: "Created date",
    enableSort: true,
    width: "16%",
  },
  QUANTITY: {
    id: "quantity",
    label: "Quantity",
    enableSort: false,
    subHead: "UOM",
    width: "16%",
  },
  LAST_MODIFIED_DATE: {
    id: "lastModifiedDate",
    label: "Last modified date",
    enableSort: true,
    width: "16%",
  },
};

export const INVENTORY_ISSUE_STOCK_COLUMNS = {
  ITEM_NAME: {
    id: "itemName",
    label: "Item name",
  },
  ISSUED_TO: {
    id: "issuedTo",
    label: "Issued to",
  },
  INSTALL_LOCATION: {
    id: "installationDetails",
    label: "Installation Location",
  },
  QUANTITY: {
    id: "quantity",
    label: "Quantity",
  },
  REASON: {
    id: "reason",
    label: "Reason",
  },
};

export const INVENTORY_ISSUE_REQUEST_COLUMNS = {
  REQ_ID: {
    id: "requestId",
    label: "Request Id",
  },
  ISSUED_TO: {
    id: "issuedTo",
    label: "Issued to",
  },
  QUANTITY: {
    id: "quantity",
    label: "Total Items",
  },
  ISSUED_BY: {
    id: "issuedBy",
    label: "Issued by",
  },
  CREATED_DATE: {
    id: "createdDate",
    label: "Created Date",
  },
  STATUS: {
    id: "status",
    label: "Status",
  },
  // ACTIONS: {
  //   id: 'actions',
  //   label: 'Actions',
  // }
};
export const INVENTORY_APPROVE_REQUEST_COLUMNS = {
  ITEM_ID: {
    id: "itemId",
    label: "Item Id",
  },
  STORE_LOCATION: {
    id: "facilityId",
    label: "Store Location",
  },
  ISSUED_TO: {
    id: "issuedTo",
    label: "Issued to",
  },
  INSTALL_LOCATION: {
    id: "installationDetails",
    label: "Installation Location",
  },
  REASON: {
    id: "reason",
    label: "Reason",
  },
  QUANTITY: {
    id: "quantity",
    label: "Quantity",
  },
  // ACTIONS: {
  //   id: 'actions',
  //   label: 'Actions',
  // }
};

export const INVENTORY_ITEM_TYPE = {
  SERIALIZED: {
    value: "SERIALIZED_INV_ITEM",
    label: "Serialized",
  },
  NON_SERIAL: {
    value: "NON_SERIAL_INV_ITEM",
    label: "Non Serialized",
  },
};

export const INVENTORY_ITEM_REASON = {
  IID_FOUND: {
    value: "IID_FOUND",
    label: "Item Found",
    show: true,
  },
  IID_SAMPLE: {
    value: "IID_SAMPLE",
    label: "Item Sample",
    show: true,
  },
  IID_INITIAL_LOAD: {
    value: "IID_INITIAL_LOAD",
    label: "Initial Load",
    show: false,
  },
  INVENTORY_TRANSFER: {
    value: "INVENTORY_TRANSFER",
    label: "Product Merge",
    show: true,
  },
};

export const INVENTORY_ITEM_DIALOG_LABELS = {
  PRODUCT_ID: {
    label: "Product ID",
    placeholder: "Enter product ID",
  },
  ITEM_ID: {
    label: "Item ID",
    placeholder: "Enter item ID",
  },
  ITEM_NAME: {
    label: "Item name",
    placeholder: "Enter item name",
  },
  INVOICE_NAME: {
    label: "Invoice Name",
    placeholder: "Enter name of your invoice",
  },
  STORE_NAME: {
    label: "Store Name",
    placeholder: "Enter Store name",
  },
  COMMON_NAME: {
    label: "Common Name",
    placeholder: "Enter common name",
  },
  DESCRIPTION: {
    label: "Description",
    placeholder: "Description about your item",
  },
  ITEM_IMG: {
    label: "Item Images",
    placeholder: "Choose images",
  },
  HSN_CODE: {
    label: "HSN/SAC",
    placeholder: "Enter HSN/SAC code",
  },
  AVAILABLE_STOCK: {
    label: "Available Stock",
    placeholder: "Enter available stock",
  },
  QTY_RECEIVED: {
    label: "Quantity Received",
    placeholder: "Enter quantity received",
  },
  RECEIVED_AGAINST: {
    label: "Received against",
    placeholder: "Select receiving against",
  },
  TAGS: {
    label: "Tags",
    placeholder: "Enter tags here",
  },
  REASON: {
    label: "Reason",
    placeholder: "Enter reason here",
  },
  ITEM_TYPE: {
    label: "Item type",
    placeholder: "Select item type",
  },
  SERIAL_NUM: {
    label: "Serial Number",
    placeholder: "Enter item serial number",
  },
  LAST_MODIFIED_DATE: {
    label: "Last Modified Date",
  },
};

export const INVENTORY_ITEM_ISSUANCE_STATUS = {
  CREATED: "ITEM_ISSUANCE_CREATED",
  APPROVED: "ITEM_ISSUANCE_APPROVED",
  ISSUED: "ITEM_ISSUED",
  CANCELLED: "ITEM_ISSUANCE_CANCELLED",
};
export const INVENTORY_ITEM_ISSUANCE_REQUEST_STATUS = {
  CREATED: "ITEM_ISSUANCE_REQ_CREATED",
  APPROVED: "ITEM_ISSUANCE_REQ_APPROVED",
  REJECTED: "ITEM_ISSUANCE_REQ_REJECTED",
  CANCELLED: "ITEM_ISSUANCE_CANCELLED",
  COMPLETED: "ITEM_ISSUANCE_COMPLETED",
};

export const SELLER_PROFILE = {
  mobileNumber: "mobileNumber",
  partyGroupName: "partyGroupName",
  address: "address",
  state: "state",
  city: "city",
  pincode: "pincode",
  emailAddress: "emailAddress",
  personName: "personName",
  panNumber: "panNumber",
  tinNumber: "tinNumber",
  gstNumber: "gstNumber",
};

export const ROLE_MAP: any = {
  REQUEST_VIEW: [
    "REQUEST_UPDATE",
    "REQUEST_DELETE",
    "REQUEST_CREATE",
    "RFQ_APPROVAL",
  ],
  PARTYMGR_UPDATE: ["PARTYMGR_ADMIN"],
  PARTYMGR_DELETE: ["PARTYMGR_ADMIN"],
  PARTYMGR_CREATE: ["PARTYMGR_ADMIN"],
  PARTYMGR_VIEW: [
    "PARTYMGR_ADMIN",
    "PARTYMGR_UPDATE",
    "PARTYMGR_DELETE",
    "PARTYMGR_CREATE",
  ],
  ORDER_UPDATE: ["ORDER_ADMIN"],
  ORDER_DELETE: ["ORDER_ADMIN"],
  ORDER_CREATE: ["ORDER_ADMIN"],
  ORDER_VIEW: ["ORDER_ADMIN", "ORDER_UPDATE", "ORDER_DELETE", "ORDER_CREATE"],
  ORDER_THREE_WAY_MATCH_VIEW: ["ORDER_THREE_WAY_MATCH_UPDATE"],
  ORDER_PAYMENT_VIEW: ["ORDER_PAYMENT_UPDATE"],
  ORDER_INVOICE_VIEW: ["ORDER_INVOICE_UPDATE"],
  REPEAT_ORDER_VIEW: [
    "REPEAT_ORDER_CREATE",
    "REPEAT_ORDER_UPDATE",
    "REPEAT_ORDER_ACCEPT",
  ],
  QUOTE_VIEW: [
    "QUOTE_CREATE",
    "QUOTE_DELETE",
    "QUOTE_UPDATE",
    "QUOTE_APPROVAL",
  ],
  ACCOUNTS_PAYABLE_UPDATE: ["ACCOUNTS_PAYABLE_ADMIN"],
  ACCOUNTS_PAYABLE_DELETE: ["ACCOUNTS_PAYABLE_ADMIN"],
  ACCOUNTS_PAYABLE_CREATE: ["ACCOUNTS_PAYABLE_ADMIN"],
  ACCOUNTS_PAYABLE_VIEW: [
    "ACCOUNTS_PAYABLE_ADMIN",
    "ACCOUNTS_PAYABLE_UPDATE",
    "ACCOUNTS_PAYABLE_DELETE",
    "ACCOUNTS_PAYABLE_CREATE",
  ],
  PRODUCTMGR_UPDATE: ["PRODUCTMGR_ADMIN"],
  PRODUCTMGR_DELETE: ["PRODUCTMGR_ADMIN"],
  PRODUCTMGR_CREATE: ["PRODUCTMGR_ADMIN"],
  PRODUCTMGR_VIEW: [
    "PRODUCTMGR_ADMIN",
    "PRODUCTMGR_UPDATE",
    "PRODUCTMGR_DELETE",
    "PRODUCTMGR_CREATE",
  ],
};

export const ADMIN_ROLES = [
  "ADMIN",
  "SUPER_ADMIN",
  "SOCIETY_ADMIN",
  "SUPERADMIN_GROUP",
];

export const DECIMAL_BOARD: any = {
  Feet: 5,
  Gm: 5,
  MTR: 5,
  Length: 5,
  LTR: 5,
  SQF: 5,
  SQM: 5,
  Ton: 5,
  REST: 2,
  CUM: 3,
  CUCM: 3,
  CUMM: 3,
  CUFT: 3,
  CUIN: 3,
  CUYD: 3,
};

export const PROFORMA_WIZARD_COLUMNS = {
  ITEM_NAME: {
    label: "Item name",
    enableSort: false,
  },
  HSN_CODE: {
    label: "HSN/SAC",
    enableSort: false,
  },
  BRAND: {
    label: "Brand",
    enableSort: false,
  },
  SPECIFICATION: {
    label: "Specification",
    enableSort: false,
  },
  UOM: {
    label: "UOM",
    enableSort: false,
  },
  Quantity: {
    label: "Quantity",
    enableSort: false,
  },
  UNIT_PRICE: {
    label: "Unit Price",
    enableSort: false,
  },
  GST: {
    label: "GST",
    enableSort: false,
  },
  AMOUNT: {
    label: "Amount",
    enableSort: false,
  },
};
export const INVOICE_WIZARD_COLUMNS = {
  ITEM_NAME: {
    label: "Item name",
    enableSort: false,
  },
  HSN_CODE: {
    label: "HSN/SAC",
    enableSort: false,
  },
  BRAND: {
    label: "Brand",
    enableSort: false,
  },
  SPECIFICATION: {
    label: "Specification",
    enableSort: false,
  },
  UOM: {
    label: "UOM",
    enableSort: false,
  },
  Quantity: {
    label: "Quantity",
    enableSort: false,
  },
  UNIT_PRICE: {
    label: "Unit Price",
    enableSort: false,
  },
  GST: {
    label: "GST",
    enableSort: false,
  },
  AMOUNT: {
    label: "Amount",
    enableSort: false,
  },
};

export const INVOICE_LIST_COLUMNS = {
  INVOICE_DATE: {
    label: "Invoice Date",
    enableSort: true,
    id: "invoiceDate",
  },
  INVOICE_CODE: {
    label: "Invoice Code",
    enableSort: false,
  },
  ORDER_CODE: {
    label: "Order Code",
    enableSort: false,
  },
  BILLED_TO: {
    label: "Billed To",
    enableSort: false,
  },
  AMOUNT: {
    label: "Amount",
    enableSort: false,
  },
  STATUS: {
    label: "Status",
    enableSort: false,
  },
  INGESTION_STATUS: {
    label: "Ingestion Status",
    enableSort: false,
  },
  PAYMENT_DATE: {
    label: "Payment Date",
    enableSort: false,
  },
};

export const dateFilters: any = {
  TODAY: {
    name: "Today",
    value: "TODAY",
  },
  WEEK: {
    name: "This Week",
    value: "WEEK",
  },
  MONTH: {
    name: "This Month",
    value: "MONTH",
  },
  YEAR: {
    name: "This Year",
    value: "YEAR",
  },
  CUSTOM: {
    name: "Custom Range",
    value: "CUSTOM",
  },
  ALL: {
    name: "All",
    value: "ALL",
  },
};

export const QUOTE_WIZARD_ITEMS: any = {
  QUOTE_NAME: {
    label: "Quote Name",
    placeholder: "Enter Quote name",
  },
  QUOTE_ID: {
    label: "Quote ID",
    placeholder: "Enter Quote ID",
  },
  QUOTE_TERMS: {
    label: "Terms and conditions",
    placeholder: "Payment terms",
  },
  QUOTE_TABLE_HEAD_ITEMS: {
    ITEM_NAME: {
      label: "Product Details",
    },
    ITEM_HSN_CODE: {
      label: "HSN Code",
      placeHolder: "HSN Code",
    },
    ITEM_SIZE: {
      label: "Specification",
    },
    ITEM_QUANTITY: {
      label: "Quantity/UOM",
    },
    ITEM_UNIT_PRICE: {
      label: "Unit Price",
      placeholder: "Unit Price",
    },
    ITEM_GST: {
      label: "GST %",
      placeholder: "Select GST",
      values: [0, 5, 12, 18, 28],
    },
    ITEM_AMOUNT: {
      label: "Amount",
      placeholder: "Amount",
    },
  },
};

export const CONTRACT_WIZARD_ITEMS: any = {
  CONTRACT_NAME: {
    label: "Contract Name",
    placeholder: "Enter Contract name",
  },
  CONTRACT_ID: {
    label: "Contract ID",
    placeholder: "Enter Contract ID",
  },
  CONTRACT_TERMS: {
    label: "Terms and conditions",
    placeholder: "Terms and conditions",
  },
  CONTRACT_REFERENCE_NUMBER: {
    label: "Contract Number",
    placeholder: "Enter Contract number",
  },
  CONTRACT_VALIDITY_DATE: {
    label: "Contract Validity Date",
    placeholder: "Contract Validity Date",
    tooltipTitle: "Date till which the contract is valid.",
  },
  CONTRACT_DELIVERY_DATE: {
    label: "Expected Delivery Date",
    placeholder: "Expected Delivery Date",
    tooltipTitle: "Date on which the contract delivery is expected.",
  },
  CONTRACT_PAYMENT_TERMS: {
    label: "Payment terms",
    placeholder: "Payment terms",
  },
  CONTRACT_BILLING_ADDRESS: {
    label: "Billing Address",
    placeholder: "Enter billing address",
  },
  CONTRACT_SHIPPING_ADDRESS: {
    label: "Shipping Address",
    placeholder: "Enter shipping address",
  },
  CONTRACT_LOCATION: {
    label: "Location",
    placeholder: "Enter location",
  },
  CONTRACT_LIMIT: {
    label: "Contract Limit ( Rs. )",
    placeholder: "Contract Limit",
  },
  CONTRACT_TABLE_HEAD_ITEMS: {
    ITEM_NAME: {
      label: "Product Details",
    },
    ITEM_HSN_CODE: {
      label: "HSN Code",
      placeHolder: "HSN Code",
    },
    ITEM_BRAND_NAME: {
      label: "Brand",
      placeHolder: "Brand",
    },
    ITEM_SIZE: {
      label: "Specification",
    },
    ITEM_QUANTITY_UOM: {
      label: "UOM",
    },
    ITEM_QUANTITY: {
      label: "Quantity",
    },
    ITEM_UNIT_PRICE: {
      label: "Unit Price",
      placeholder: "Unit Price",
    },
    ITEM_GST: {
      label: "GST %",
      placeholder: "Select GST",
      values: [0, 5, 12, 18, 28],
    },
    ITEM_AMOUNT: {
      label: "Amount",
      placeholder: "Amount",
    },
  },
};

export const BUSINESS_DETAILS = {
  personName: "personName",
  address: "address",
  state: "state",
  city: "city",
  pincode: "pincode",
  mobileNumber: "mobileNumber",
  emailAddress: "emailAddress",
  partyGroupName: "partyGroupName",
  password: "password",
  gstNumber: "gstNumber",
  panNumber: "panNumber",
  tinNumber: "tinNumber",
  partyTypeId: "partyTypeId",
  partyGroupRole: "partyGroupRole",
  personRole: "personRole",
  brand: "brand",
  productType: "productType",
};

export const PartyProductType_STATUSES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "IN_ACTIVE",
};

export const CREATE_GRN_TABLE_HEADINGS = {
  PRODUCT_DETAILS: "Product details",
  HSN_CODE: "HSN Code",
  SPECIFICATION: "Specification",
  QUANTITY: "Quantity",
  UOM: "UOM",
};

export const DISCOUNT_ITEM_TYPES = [
  "INVOICE_ADJ",
  "INVOICE_HEAD_ADJ",
  "SINVOICE_HEAD_ADJ",
  "INV_DISCOUNT_ADJ",
  "INVOICE_ITM_ADJ",
  "SINVOICE_ITM_ADJ",
  "ITM_DISCOUNT_ADJ",
  "PITM_DISCOUNT_ADJ",
];
export const SURPLUS_ITEM_TYPES = [
  "SHIPPING_CHARGES",
  "SHIPPING_CHARGES_CARTAGE",
];
export const ROWS_PER_PAGES = [10, 25, 50, 75];
export const ADJUSTMENT_LIST = [
  {
    type: "DISCOUNT_ADJUSTMENT",
    label: "Discount",
  },
  {
    type: "ROUNDING_OFF_POSITIVE",
    label: "Round Off",
  },
];

export const INGESTION_STATUS_COLORS = {
  SAVED: "#6C757D",
  PROCESSED: "#49A22C",
  SUCCESS: "#49A22C",
  PUSHED: "#F0A235",
  FAILED: "#DF2E31",
  UPDATED: "#0EA5E9",
  DEFAULT: "#6C757D",
};

export const SUBSCRIPTION_INTERVAL = {
  YEARLY: "YEARLY",
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
  FREE_TIER: "2025-09-30T23:59:59",
};

export const PRODUCT_LIST_COLUMNS = {
  PRODUCT_ID: {
    id: "internalCode",
    label: "Product ID",
    enableSort: true,
    width: "18%",
  },
  ITEM_NAME: {
    id: "productName",
    label: "Product Name",
    enableSort: true,
    width: "18%",
  },
  HSN_CODE: {
    id: "hsnCode",
    label: "HSN/SAC",
    enableSort: true,
    width: "18%",
  },
  BRAND_NAME: {
    id: "brandName",
    label: "Brand Name",
    enableSort: true,
    width: "18%",
  },
  SPECIFICATION: {
    id: "description",
    label: "Description",
    enableSort: false,
    width: "18%",
  },
  ACTIONS: {
    id: "actions",
    label: "",
    enableSort: false,
    width: "10%",
  },
};

export const BULK_INVENTORY_WIZARD = {
  ITEM_ID: {
    id: "facilityId",
    label: "Facility Name",
  },
  AVAILABLE_QTY: {
    id: "availableQty",
    label: "Available Quantity",
  },
  PRODUCT_TYPE: {
    id: "productType",
    label: "Product Type",
  },
  ITEM_NAME: {
    id: "itemName",
    label: "Item Name",
  },
  HSN_CODE: {
    id: "hsnCode",
    label: "HSN Code",
  },
  BRAND_NAME: {
    id: "brandName",
    label: "Brand Name",
  },
  LAST_MODIFIED_DATE: {
    id: "quantityUOM",
    label: "Quantity UOM",
  },
  ACTIONS: {
    id: "actions",
    label: "",
  },
};

export const DEVICE_TYPES = {
  MOBILE: "MOBILE",
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
};

export const PROFORMA_LIST_COLUMNS = {
  PROFORMA_ID: {
    label: "Proforma ID",
    enableSort: false,
    colSpan: 3,
  },
  PROFORMA_INVOICE_NUMBER: {
    label: "Proforma Invoice No",
    enableSort: false,
    colSpan: 3,
  },
  AMOUNT: {
    label: "Amount",
    enableSort: false,
    colSpan: 2,
  },
  CLIENT: {
    label: "Client",
    enableSort: false,
    colSpan: 2,
  },
  CREATED_DATE: {
    label: "Created Date",
    enableSort: false,
    colSpan: 2,
  },
};

export const dashboardOrderStatusBoard: { [key: string]: string } = {
  Created: "ORDER_CREATED",
  Processing: "ORDER_PROCESSING",
  Delivered: "ORDER_DELIVERED",
  "Invoice created": "INVOICE_CREATED",
  "Invoice Accepted": "ORDER_ACCEPTED",
  // Cancelled: "ORDER_CANCELLED",
  Completed: "ORDER_COMPLETED",
};

export const ADJUSTMENT_TYPES = {
  DISCOUNT_ADJUSTMENT: {
    id: "DISCOUNT_ADJUSTMENT",
    label: "Discount",
  },
  ROUND_OFF_ADJUSTMENT: {
    id: "ROUNDING_OFF_POSITIVE",
    label: "Round Off",
  },
};

export const ADJUSTMENT_ITEM_TYPES = {
  DISCOUNT_ITEM_TYPES: [
    "INVOICE_ADJ",
    "INVOICE_HEAD_ADJ",
    "SINVOICE_HEAD_ADJ",
    "INV_DISCOUNT_ADJ",
    "INVOICE_ITM_ADJ",
    "SINVOICE_ITM_ADJ",
    "ITM_DISCOUNT_ADJ",
    "PITM_DISCOUNT_ADJ",
  ],
  SURPLUS_ITEM_TYPES: ["SHIPPING_CHARGES", "SHIPPING_CHARGES_CARTAGE"],
};

export const CONTACT_DETAILS = {
  CONTACT_MECH: {
    POSTAL_ADDRESS: "POSTAL_ADDRESS",
    EMAIL_ADDRESS: "EMAIL_ADDRESS",
    TELECOM_NUMBER: "TELECOM_NUMBER",
  },
  PURPOSE_TYPE: {
    SHIPPING_LOCATION: "SHIPPING_LOCATION",
    BILLING_LOCATION: "BILLING_LOCATION",
    PRIMARY_EMAIL: "EMAIL",
    PRIMARY_PHONE: "PRIMARY_PHONE",
  },
  ADDRESS_FIELDS: {
    ADDRESS1: "address1",
    CITY: "city",
    STATE: "state",
    PINCODE: "pincode",
  },
};

export const COOKIE_NAMES = {
  jwtToken: "jwtTokenBuyer",
  tokenExpiryTime: "tokenExpiryTimeBuyer",
  orgPartyName: "orgPartyNameBuyer",
  prismUser: "prismUserBuyer",
  subscription: "subscriptionBuyer",
};

export const DASHBOARD_CONSTANTS = {
  PAGE_SIZES: [10, 25, 50, 100],
  STATUS_FILTER: {
    ORDER: {
      DEFAULT: {
        id: "",
        name: "",
      },
      ALL: {
        id: "ALL",
        name: "All",
      },
      CREATED: {
        id: "ORDER_CREATED",
        name: "Created",
      },
      DRAFT: {
        id: "ORDER_DRAFT",
        name: "Draft",
      },
      PROCESSING: {
        id: "ORDER_PROCESSING",
        name: "Processing",
      },
      DELIVERED: {
        id: "ORDER_DELIVERED",
        name: "Delivered",
      },
      INVOICE_CREATED: {
        id: "INVOICE_CREATED",
        name: "Invoice created",
      },
      THREE_WAY_MATCH_APPROVED: {
        id: "ORDER_ACCEPTED",
        name: "Invoice Accepted",
      },
      REJECTED: {
        id: "ORDER_REJECTED",
        name: "Rejected",
      },
      CANCELLED: {
        id: "ORDER_CANCELLED",
        name: "Cancelled",
      },
      CLOSED: {
        id: "ORDER_CLOSED",
        name: "Closed",
      },
      COMPLETED: {
        id: "ORDER_COMPLETED",
        name: "Completed",
      },
      UPDATED: {
        id: "ORDER_UPDATED",
        name: "Updated",
      },
    },
    DELIVERY_CHALLAN: {
      Default: {
        id: "",
        name: "",
      },
      ALL: {
        id: "GRN_ALL",
        name: "All",
      },
      DRAFT: {
        id: "GRN_DRAFT",
        name: "Draft",
      },
      CREATED: {
        id: "GRN_CREATED",
        name: "Created",
      },
      DELIVERED: {
        id: "GRN_DELIVERED",
        name: "Delivered",
      },
      DISPATCHED: {
        id: "GRN_DISPATCHED",
        name: "Dispatched",
      },
      PENDING_ACK: {
        id: "GRN_PENDING_ACKNOWLEDGEMENT",
        name: "Pending Ack",
      },
    },
  },
  TABS: {
    ORDERS: "ORDERS",
    DELIVERY_CHALLANS: "DELIVERY_CHALLANS",
    INVOICES: "INVOICES",
  },
};

export const DATE_FILTERS = {
  TODAY: {
    name: "Today",
    value: "TODAY",
  },
  WEEK: {
    name: "This Week",
    value: "WEEK",
  },
  MONTH: {
    name: "This Month",
    value: "MONTH",
  },
  YEAR: {
    name: "This Year",
    value: "YEAR",
  },
  CUSTOM: {
    name: "Custom Range",
    value: "CUSTOM",
  },
  ALL: {
    name: "All",
    value: "ALL",
  },
};

export const FILE_TYPES = {
  CSV: ".csv",
  GOOGLE_SHEET:
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  MSEXCEL: "application/vnd.ms-excel",
  PDF: "application/pdf",
  JPEG: "image/jpeg",
  PNG: "image/png",
  MSWORD: "application/msword",
  GOOGLE_DOCS:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC: ".doc",
  DOCX: ".docx",
};

export const GST_VALUES = [0, 5, 12, 18, 28];

export const LOADERS = {
  NOT_LOADING: "",
  CREATE_ORDER: "CREATE_ORDER",
  FETCHING_ORDER: "FETCHING_ORDER",
  UPDATING_ORDER: "UPDATING_ORDER",
  REMAINING_ITEMS_PDF: "REMAINING_ITEMS_PDF",
  FETCHING_ACCOUNTS_PAYABLE: "FETCHING_ACCOUNTS_PAYABLE",
  FETCHING_INVOICE_PDF: "FETCHING_INVOICE_PDF",
  UPLOADING_INVOICE: "UPLOADING_INVOICE",
  RECORDING_PAYMENT: "RECORDING_PAYMENT",
  GETTING_PAYMENT_METHOD_TYPES: "GETTING_PAYMENT_METHOD_TYPES",
  GETTING_PAYMENT_TYPES: "GETTING_PAYMENT_TYPES",
  GRN_ACKNOWLEDGMENT: "GRN_ACKNOWLEDGMENT",
  FETCHING_GRN: "FETCHING_GRN",
  ACCEPT_ORDER: "ACCEPT_ORDER",
  THREE_WAY: "THREE_WAY",
  FETCHING_TRACKING: "FETCHING_TRACKING"
};

export const ORDER_WIZARD_ITEMS = {
  ORDER_NAME: {
    label: "Order Name",
    placeholder: "Enter Order name",
    id: "orderName",
  },
  ORDER_ID: {
    label: "Order ID",
    placeholder: "Enter Order ID",
    id: "orderId",
  },
  ORDER_TERMS: {
    label: "Terms and conditions",
    placeholder: "Terms and conditions",
    id: "termsAndConditions",
  },
  ORDER_REFERENCE_NUMBER: {
    label: "Order Number",
    placeholder: "Enter PO number",
    id: "referenceNumber",
  },
  ORDER_REFERENCE_DATE: {
    label: "Order Date",
    placeholder: "Order Date",
    tooltipTitle: "Date on which the order is raised.",
    id: "referenceDate",
  },
  ORDER_DELIVERY_DATE: {
    label: "Expected Delivery Date",
    placeholder: "Expected Delivery Date",
    tooltipTitle: "Date on which the order delivery is expected.",
    id: "expectedDeliveryDate",
  },
  ORDER_PAYMENT_TERMS: {
    label: "Payment terms",
    placeholder: "Payment terms",
    id: "paymentTerms",
  },
  ORDER_BILLING_ADDRESS: {
    label: "Billing Address",
    placeholder: "Enter billing address",
  },
  ORDER_SHIPPING_ADDRESS: {
    label: "Shipping Address",
    placeholder: "Enter shipping address",
  },
  ORDER_TABLE_HEAD_ITEMS: {
    ITEM_NAME: {
      label: "Product Details",
      id: "item",
      width: "14%",
      placeholder: "Item Name",
    },
    ITEM_HSN_CODE: {
      label: "HSN Code",
      placeholder: "HSN Code",
      id: "hsnCode",
      width: "10%",
    },
    ITEM_BRAND_NAME: {
      label: "Brand",
      placeholder: "Brand",
      id: "brandName",
      width: "12%",
    },
    ITEM_SIZE: {
      label: "Specification",
      id: "size",
      width: "13%",
      placeholder: "Specification",
    },
    ITEM_QUANTITY_UOM: {
      label: "UOM",
      id: "quanityUOM", // Quanity since its wrong in model of original collection
      width: "10%",
      placeholder: "UOM",
    },
    ITEM_QUANTITY: {
      label: "Quantity",
      id: "quantity",
      width: "13%",
      placeholder: "Quantity",
    },
    ITEM_UNIT_PRICE: {
      label: "Unit Price",
      placeholder: "Unit Price",
      id: "unitPrice",
      width: "12%",
    },
    ITEM_GST: {
      label: "GST %",
      placeholder: "GST %",
      values: [0, 5, 12, 18, 28],
      id: "gst",
      width: "8%",
    },
    ITEM_AMOUNT: {
      label: "Amount",
      placeholder: "Amount",
      id: "amount",
      width: "15%",
    },
    ITEM_ACTION: {
      label: "",
      placeholder: "",
      id: "actions",
      width: "3%",
    },
  },
};

export const PARTY_STATUS = {
  ACTIVE: "PARTY_ACTIVE",
  INACTIVE: "PARTY_IN_ACTIVE",
};

export const RELATIONSHIP_TYPES = {
  PREFERRED_VENDOR: "PREFERRED_VENDOR",
};

export const STATUS = {
  PAYMENT_STATUS: {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
    UPLOADED: "UPLOADED",
  },
  THREE_WAY_MATCH_STATUS: {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
  },
  ORDER: {
    ORDER_APPROVED: {
      id: "ORDER_APPROVED",
      name: "Approved",
    },
    ORDER_DRAFT: {
      id: "ORDER_DRAFT",
      name: "Draft",
    },
    ORDER_CREATED: {
      id: "ORDER_CREATED",
      name: "Created",
    },
    ORDER_CLOSED: {
      id: "ORDER_CLOSED",
      name: "Closed",
    },
    ORDER_REJECTED: {
      id: "ORDER_REJECTED",
      name: "Rejected",
    },
    ORDER_CANCELLED: {
      id: "ORDER_CANCELLED",
      name: "Cancelled",
    },
    ORDER_PROCESSING: {
      id: "ORDER_PROCESSING",
      name: "Processing",
    },
    ORDER_DELIVERED: {
      id: "ORDER_DELIVERED",
      name: "Delivered",
    },
    INVOICE_CREATED: {
      id: "INVOICE_CREATED",
      name: "Invoice created",
    },
    THREE_WAY_MATCH_APPROVED: {
      id: "THREE_WAY_MATCH_APPROVED",
      name: "Invoice Accepted",
    },
    THREE_WAY_MATCH_REJECTED: {
      id: "THREE_WAY_MATCH_REJECTED",
      name: "3 way match rejected",
    },
    "3_WAY_MATCH_REJECTED": {
      id: "3_WAY_MATCH_REJECTED",
      name: "3 way match rejected",
    },
    PAYMENT_APPROVED: {
      id: "PAYMENT_APPROVED",
      name: "Payment approved",
    },
    ORDER_SUBMITTED: {
      id: "ORDER_SUBMITTED",
      name: "Submitted",
    },
    ORDER_INTRANSIT: {
      id: "ORDER_INTRANSIT",
      name: "Intransit",
    },
    ORDER_DELAYED: {
      id: "ORDER_DELAYED",
      name: "Delayed",
    },
    ORDER_ACCEPTED: {
      id: "ORDER_ACCEPTED",
      name: "Invoice Accepted",
    },
    ORDER_COMPLETED: {
      id: "ORDER_COMPLETED",
      name: "Completed",
    },
    PAYMENT_REJECTED: {
      id: "PAYMENT_REJECTED",
      name: "Payment rejected",
    },
    ORDER_UPDATED: {
      id: "ORDER_UPDATED",
      name: "Updated",
    },
  },
  GRN: {
    GRN_DRAFT: {
      id: "GRN_DRAFT",
      name: "Draft",
    },
    GRN_CREATED: {
      id: "GRN_CREATED",
      name: "Created",
    },
    GRN_DELIVERED: {
      id: "GRN_DELIVERED",
      name: "Delivered",
    },
    GRN_DISPATCHED: {
      id: "GRN_DISPATCHED",
      name: "Dispatched",
    },
    GRN_REJECTED: {
      id: "GRN_REJECTED",
      name: "Rejected",
    },
    GRN_PENDING_ACKNOWLEDGEMENT: {
      id: "GRN_PENDING_ACKNOWLEDGEMENT",
      name: "Pending Ack",
    },
    API_DELIVERED: {
      id: "API_DELIVERED",
      name: "GRN_DELIVERED",
    },
    API_REJECTED: {
      id: "API_REJECTED",
      name: "GRN_REJECTED",
    },
    API_CREATED: {
      id: "API_CREATED",
      name: "GRN_CREATED",
    },
    API_PENDING_ACKNOWLEDGEMENT: {
      id: "API_PENDING_ACKNOWLEDGEMENT",
      name: "GRN_PENDING_ACKNOWLEDGEMENT",
    },
  },
  RFQ: {
    RFQ_DRAFT: {
      id: "RFQ_DRAFT",
      name: "Draft",
    },
    RFQ_CREATED: {
      id: "RFQ_CREATED",
      name: "Created",
    },
    RFQ_APPROVED: {
      id: "RFQ_APPROVED",
      name: "Approved",
    },
    RFQ_COMPLETED: {
      id: "RFQ_COMPLETED",
      name: "Completed",
    },
    RFQ_REJECTED: {
      id: "RFQ_REJECTED",
      name: "Rejected",
    },
    RFQ_CLOSED: {
      id: "RFQ_CLOSED",
      name: "Closed for Bidding",
    },
    RFQ_UPDATED: {
      id: "RFQ_UPDATED",
      name: "Updated",
    },
    REQUEST_APPROVED: {
      id: "REQUEST_APPROVED",
      name: "Bidding Open",
    },
    REQUEST_DRAFT: {
      id: "REQUEST_DRAFT",
      name: "Draft",
    },
    REQUEST_CREATED: {
      id: "REQUEST_CREATED",
      name: "Created",
    },
    REQUEST_COMPLETED: {
      id: "REQUEST_COMPLETED",
      name: "Completed",
    },
    REQUEST_REJECTED: {
      id: "REQUEST_REJECTED",
      name: "Rejected",
    },
    REQUEST_UPDATE: {
      id: "REQUEST_UPDATE",
      name: "Draft",
    },
    REQUEST_CLOSED: {
      id: "REQUEST_CLOSED",
      name: "Closed for Bidding",
    },
    REQUEST_UPDATED: {
      id: "REQUEST_UPDATED",
      name: "Updated",
    },
  },
  ITEMS: {
    Default: {
      id: "",
      name: "",
    },
    ITEM_DRAFT: {
      id: "ITEM_DRAFT",
      name: "Draft",
    },
    ITEM_CREATED: {
      id: "ITEM_CREATED",
      name: "Created",
    },
    ITEM_APPROVED: {
      id: "ITEM_APPROVED",
      name: "Approved",
    },
    ITEM_REJECTED: {
      id: "ITEM_REJECTED",
      name: "Rejected",
    },
    ITEM_COMPLETED: {
      id: "ITEM_COMPLETED",
      name: "Completed",
    },
    ITEM_DELIVERED: {
      id: "ITEM_DELIVERED",
      name: "Delivered",
    },
    ITEM_RETURNED: {
      id: "ITEM_RETURNED",
      name: "Returned",
    },
    ITEM_PARTIALLY_ACCEPTED: {
      id: "ITEM_PARTIALLY_ACCEPTED",
      name: "Partially Accepted",
    },
    ITEM_PARTIALLY_RETURNED: {
      id: "ITEM_PARTIALLY_RETURNED",
      name: "Partially Returned",
    },
    ITEM_CANCELLED: {
      id: "ITEM_CANCELLED",
      name: "Cancelled",
    },
  },
  INVOICE: {
    INVOICE_CANCELLED: {
      id: "INVOICE_CANCELLED",
      name: "Cancelled",
    },
  },
};
